// @flow

import fuzzysearch from 'fuzzysearch';
import { isEmpty, sortBy, take, takeWhile, toLower, uniqBy } from 'lodash';

import type { Service } from '@zapier/services/src/types';

const POPULARITY_RANK_EFFECT = 2;
const MAX_RESULTS_TO_SHOW = 12;

const serviceScorer = (query: string) => (service: Service) => {
  const { name, title, categories, popularity } = service;
  const nameOrTitle = toLower(name || title || '');
  const category = toLower((categories && categories.join(' ')) || '');

  let score = 0;

  // Score by title
  if (nameOrTitle === query) score += 100;
  else if (nameOrTitle.includes(query)) score += 50;
  else if (fuzzysearch(query, nameOrTitle.toLowerCase())) score += 10;

  // Score by category
  if (category === query) score += 50;
  else if (category.includes(query)) score += 25;
  else if (fuzzysearch(query, category)) score += 5;

  // Factor in popularity
  if (popularity) score *= 1 + POPULARITY_RANK_EFFECT / popularity;

  return score;
};

export const getServiceTitle = (service: Service) =>
  service && (service.name || service.title);

const search = (query: string, services: Array<Service>) => {
  const cleanQuery = query && query.trim().toLowerCase();
  if (isEmpty(cleanQuery)) {
    return services;
  }

  const scorer = serviceScorer(cleanQuery);
  const sorted = uniqBy(sortBy(services, scorer).reverse(), getServiceTitle);
  const results = takeWhile(take(sorted, MAX_RESULTS_TO_SHOW), scorer);

  return results;
};

export default search;
